export default "__VITE_ASSET__CGx_0PXY__"